// DELETE / BACKSPACE removes the selected element(s) (2026-10-14, owner:
// « I can't delete the sticker »). The editor had no such key at all — only
// the pill's trash, the « ••• » toolbar's trash and the right panel's
// « Supprimer ». Pure, so the rule is tested without the 22k-line page.
//
// Only the client's OWN elements (no `layer`): a model's pieces, its photo
// windows and its text holders follow the model's rules (« Retirer » on a
// window asks the worker; decorations are not the client's to remove).

export interface KeyLike { key: string; ctrlKey?: boolean; metaKey?: boolean; altKey?: boolean }

/** Delete or Backspace, no modifier (Cmd+Backspace stays the browser's). */
export function isDeleteKey(e: KeyLike): boolean {
  return (e.key === 'Delete' || e.key === 'Backspace') && !e.ctrlKey && !e.metaKey && !e.altKey;
}

/** The key belongs to whatever the person is typing in. */
export function isTypingTarget(t: { tagName?: string; isContentEditable?: boolean } | null | undefined): boolean {
  if (!t) return false;
  return t.tagName === 'INPUT' || t.tagName === 'TEXTAREA' || t.tagName === 'SELECT' || !!t.isContentEditable;
}

/** The selected elements the key may delete, with their page. */
export function keyDeletable(
  pages: ReadonlyArray<{ page: number; elements?: ReadonlyArray<{ id: string; layer?: string }> | null }>,
  selected: Iterable<string>,
): Array<{ pageNumber: number; id: string }> {
  const want = new Set(selected);
  const out: Array<{ pageNumber: number; id: string }> = [];
  for (const p of pages) {
    for (const el of p.elements ?? []) {
      if (want.has(el.id) && !el.layer) out.push({ pageNumber: p.page, id: el.id });
    }
  }
  return out;
}
